module.exports = __webpack_public_path__ + "static/media/DOLA.b374396c.png";